export { createLazyResolver } from './createLazyResolver';
export { createLazySubscriptionResolver } from './createLazySubscriptionResolver';
export { createLazyLocalMutationResolver } from './createLazyLocalMutationResolver';
